<span class="badge mr-3" [ngClass]="elClass">
    <b>{{elTranslation | translate}}</b>
    <ng-content select="[status-content]"></ng-content>
</span>